import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    viewMoreAiResults: (count: number) => string;
    viewStandardResults: (count: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the button that shows how many AI-powered results are available */
            viewMoreAiResults: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchNlpUpsellFooter.viewMoreAiResults?c=t7cvokap2dai", defaultMessage: "View AI Results ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the button that links back to Standard Results from AI Results tab */
            viewStandardResults: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchNlpUpsellFooter.viewStandardResults?c=3bnh1u4p9mieg", defaultMessage: "View Standard Results ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
